import { keyframes } from '@emotion/core';
import { blue } from './core';

export const bounce = keyframes`
  from,
  to { 
    transform: translateY(70px);
    opacity: 0;
  }

  10%,
  90% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const breathe = keyframes`
  from,
  to {
    transform: translateX(-16px);
  }

  50% {
    transform: translateX(16px);
  }
`;

export const scaleUp = keyframes`
  from {
    transform: scale(.9);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const appearFall = keyframes`
  from {
    opacity: 0;
    transform: translateY(-80px) scale(.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const appearDrop = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px) scale(.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0; 
  }

  to {
    opacity: 1;
  }
`;
export const fadeOut = keyframes`
  from {
    opacity: 1; 
  }

  to {
    opacity: 0;
  }
`;

export const pulse = keyframes`
  from,
  to {
    background: ${blue};
    -webkit-background-clip: text;
  }

  50% {
    background: mix(${blue}, #fff, 60);
    -webkit-background-clip: text;
  }
`;

export const loading = keyframes`
  from,
  to {
    color: rgba(#000, .6);
  }

  50% {
    color: rgba(#000, .1);
  }
`;

const _refreshing = (from, to) => keyframes`
  from,
  to {
    opacity: ${from};
  }

  50% {
    opacity: ${to};
  }
`;

export const refreshingSubtle = _refreshing(1, 0.5);
export const refreshing = _refreshing(0.85, 0.4);

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
